/**
 * @package module.billing
 * @author Artem Ilinykh devsinglesly@gmail.com
 * @class BillingPeriodRow
 */
import { Type } from 'class-transformer';
import { Rate } from '@/modules/backend/Entities/Rate';
import { CounterData } from '@/modules/backend/Entities/CounterData';
import { Counter } from '@/modules/backend/Entities/Counter';

export class BillingPeriodRow {
  @Type(() => Rate)
  public readonly rate!: Rate;

  @Type(() => CounterData)
  public readonly data!: CounterData[];

  public readonly summary!: number;

  @Type(() => Date)
  public readonly to!: Date;

  @Type(() => Date)
  public readonly from!: Date;

  public get counter(): Counter | undefined {
    return this.data[0].getCounter() || undefined;
  }
}
